/** Current VAT choices supported by the application. */
export const VAT_RATE_OPTIONS = [0, 1, 10, 20] as const;

/** UI fallback only; persisted company settings always come from the backend. */
export const DEFAULT_VAT_RATE = 20;

export const isSupportedVatRate = (value: number): boolean =>
  VAT_RATE_OPTIONS.includes(value as (typeof VAT_RATE_OPTIONS)[number]);
